import { render, staticRenderFns } from "./StudentHomeworkReportTable.vue?vue&type=template&id=16d26974"
import script from "./StudentHomeworkReportTable.vue?vue&type=script&lang=js"
export * from "./StudentHomeworkReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports